import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import WorkspaceList from './components/WorkspaceList'
import WorkspaceEditor from './components/WorkspaceEditor'
import Header from './components/Header'

// AWS CloudFormation Launch Stack URL
const TEMPLATE_URL = 'https://structurizr-serverless-dist.s3.us-west-2.amazonaws.com/templates/structurizr.template.json'
const LAUNCH_STACK_URL = `https://console.aws.amazon.com/cloudformation/home#/stacks/quickcreate?templateURL=${encodeURIComponent(TEMPLATE_URL)}&stackName=structurizr`

// Custom components for the Authenticator
const authenticatorComponents = {
  Header() {
    return (
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Structurizr Serverless</h1>
        <p className="text-gray-600">C4 Architecture Diagramming</p>
      </div>
    )
  },
  Footer() {
    return (
      <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-sm text-gray-600 text-center mb-3">
          Want your own private instance?
        </p>
        <a
          href={LAUNCH_STACK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full"
        >
          <img
            src="https://s3.amazonaws.com/cloudformation-examples/cloudformation-launch-stack.png"
            alt="Launch Stack"
            className="h-8"
          />
        </a>
        <p className="text-xs text-gray-500 text-center mt-2">
          Deploy to your own AWS account in minutes
        </p>
      </div>
    )
  },
  // Hide "Forgot your password?" link
  SignIn: {
    Footer() {
      return null
    },
  },
}

function App() {
  return (
    <Authenticator components={authenticatorComponents} hideSignUp={true}>
      {({ signOut, user }) => (
        <BrowserRouter>
          <div className="min-h-screen bg-gray-100">
            <Header user={user} onSignOut={signOut} />
            <main className="container mx-auto px-4 py-6">
              <Routes>
                <Route path="/" element={<WorkspaceList />} />
                <Route path="/workspace/:id" element={<WorkspaceEditor />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </BrowserRouter>
      )}
    </Authenticator>
  )
}

export default App
